import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Webcam from "react-webcam";
import Arrow from './arrowoptum.gif'
import axios from "axios";

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,

} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { getroles } from "service/myapi";
import { addUser, getClinic } from "../../service/api";


const AddUser = () => {

  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    staff_mobile: "",
    address: "",
    code: "",
    userType: "",
    dob: "",
    password: "",
    gender: "",
    clinic: "",
    empstatus: "",
    perslno: "",
    staffquli: "",
    povince: "",
    district: "",
    subdistrict: "",
    sancnumbe: "",
    hpsanumber: "",
  }

  const [formData, setFormData] = useState(initialValues);
  const [myroles, setallroles] = useState([]);
  const [allcliniclist, setallclinics] = useState([]);
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    password: false,
    staff_mobile: false,
    clinic: false,
    userType: false,
  });



  useEffect(() => {
    getallroles();
    getallclinics();
  }, []);

  const getallroles = async () => {
    try {
      const response = await getroles();
      setallroles(response.data.roles);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  const getallclinics = async () => {
    let response = await getClinic();
    setallclinics(response.data);
    console.log(response.data);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation checks
    let validationErrors = {};
    validationErrors.name = formData.name === "";
    validationErrors.email = formData.email === "";
    validationErrors.password = formData.password === "";
    validationErrors.staff_mobile = formData.staff_mobile === "";
    validationErrors.clinic = formData.clinic === "";
    validationErrors.userType = formData.userType === "";
    setErrors(validationErrors);

    if (!validationErrors.name && !validationErrors.email && !validationErrors.password && !validationErrors.staff_mobile && !validationErrors.clinic && !validationErrors.userType) {
      await addUser(formData);
      console.log(formData);
      toast.success("User saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   await addUser(formData);
  //   console.log(formData);
  //   toast.success("User saved successfully.", {
  //     position: "top-center",
  //     autoClose: 1500,
  //   })
  // };

  const [imageSrc, setImageSrc] = useState('');
  const [webcamOpen, setWebcamOpen] = useState(false);
  const [showArrow, setShowArrow] = useState(true);

  const videoConstraints = {
    width: 400,
    height: 290,
    facingMode: "user"
  };

  const webcamRef = useRef(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <div className="d-flex justify-content-between align-items-center mb-4">
            <h1 className="page-title"></h1>
            <Link to="/Users" className="btn btn-danger">VIEW Staff LIST</Link>
          </div> */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
            <h4 className="page-title">ADD STAFF</h4>
            <Link to="/Users" className="btn btn-danger">VIEW Staff LIST</Link>

          </div>
          {/* Render Breadcrumbs */}
          {/* <Breadcrumbs title="Setting" breadcrumbItem="ADD STAFF" /> */}
          <Row>
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">Staff Full Name<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter Name"
                          name="name"
                          onChange={handleChange}
                        />
                        {errors.name && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-brandProductI-Input">Staff Email<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <Input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter Email"
                          // value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-password-Input">Password<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <Input
                          type="password"
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Enter new password"
                          // value={formData.password}
                          onChange={handleChange}
                        />
                        {errors.password && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">Staff Contact No.<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="mobile"
                          name="staff_mobile"
                          placeholder="Eg. +27843938590"
                          // value={formData.mobile}
                          onChange={handleChange}
                        />
                        {errors.staff_mobile && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">Date Of Birth</Label>
                        <Input
                          type="date"
                          className="form-control"
                          id="dob"
                          name="dob"
                          placeholder="Date Of Birth"
                          // value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Geder</Label>
                        <select
                          name="gender"
                          className="form-control"
                          onChange={handleChange}>
                          <option defaultValue>Select</option>
                          <option>Male</option>
                          <option>Female</option>
                          <option>Other</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={2}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Practice<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <select name="clinic" id="clinic" className="form-control" onChange={handleChange}>
                          <option defaultValue>Choose...</option>
                          {allcliniclist.map((clinic) => (
                            <option key={clinic._id} value={clinic._id}>
                              {clinic.name}
                            </option>
                          ))}
                        </select>
                        {errors.clinic && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Employment Status</Label>
                        <select
                          name="empstatus"
                          className="form-control"
                          onChange={handleChange}>
                          <option defaultValue>Select</option>
                          <option>Permanent</option>
                          <option>Intern</option>
                          <option>Contract</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">Persal Number</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="perslno"
                          name="perslno"
                          // value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">Staff Qualification</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="staffquli"
                          name="staffquli"
                          placeholder="staff qualification"
                          // value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Province</Label>
                        <select
                          name="povince"
                          className="form-control"
                          onChange={handleChange}>
                          <option defaultValue>Select</option>
                          <option>Gauteng</option>
                          <option>Limpopo</option>
                          <option>North West</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">District</Label>
                        <select
                          name="district"
                          className="form-control"
                          onChange={handleChange}>
                          <option defaultValue>Select</option>
                          <option>Tshwane MM</option>
                          <option>West Rand DM</option>
                          <option>Makhado</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Sub District</Label>
                        <select
                          name="subdistrict"
                          className="form-control"
                          onChange={handleChange}>
                          <option defaultValue>Select</option>
                          <option>Tshwane 1 SD</option>
                          <option>Elim</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">SANC Number</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="sancnumbe"
                          name="sancnumbe"
                          // value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-name-Input">HPCSA</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="sancnumbe"
                          name="hpsanumber"
                          placeholder="HPSA"
                          // value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-composition-Input">Address</Label>
                        <Input
                          type="textarea"
                          className="form-control"
                          id="address"
                          name="address"
                          placeholder="Enter Address"
                          // value={formData.address}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-phone-Input">Alternative No.</Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="alt_mobile"
                          placeholder="Enter Phone Number"
                          // value={formData.mobile}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-code-Input">Saff Code</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="code"
                          name="code"
                          placeholder="Enter Code"
                          // value={formData.code}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">Staff Type<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                        <select
                          id="userType"
                          name="userType"
                          className="form-control"
                          // value={formData.userType}
                          onChange={handleChange}
                        >
                          <option defaultValue>Select Role...</option>
                          {myroles.length > 0 ? (
                            myroles.map((role) => (
                              <option key={role._id} value={role.role}>{role.role}</option>
                            ))
                          ) : (
                            <option disabled>Loading roles...</option>
                          )}
                        </select>
                        {errors.userType && <span className="text-danger">*Please fill out this field</span>}
                      </div>
                    </Col>
                    {/* Live Image Capture */}
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="live-image-capture">Live Image Capture</Label>
                        <Row>
                          <Col md={5}>
                            {webcamOpen ? (
                              <div>
                                <Webcam
                                  audio={false}
                                  ref={webcamRef}
                                  screenshotFormat="image/jpeg"
                                  videoConstraints={videoConstraints}
                                />
                                <Button onClick={() => capture(webcamRef)} color="primary" style={{ marginRight: '18px' }} className="mt-2">
                                  Capture
                                </Button>
                                <Button onClick={() => setWebcamOpen(false)} color="secondary" className="mt-2 ml-2">
                                  Close
                                </Button>
                              </div>
                            ) : (
                              <div>
                                <Button onClick={() => { setWebcamOpen(true); setShowArrow(false); }} color="primary">
                                  Open Webcam
                                </Button>
                                {showArrow && (
                                  <img src={Arrow} alt="arrow" style={{ width: '40px', height: '40px', marginTop: '8px', marginRight: '450px' }} />
                                )}
                              </div>
                            )}
                          </Col>
                          <Col md={3
                          }>
                            {imageSrc && (
                              <div className="mt-3">
                                <img src={imageSrc} alt="Captured" className="img-fluid" />
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <button type="submit" className="btn btn-primary w-md mx-2">
                      ADD
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddUser;
